import React__default from 'react';
import { useController } from 'react-hook-form';
import { Checkbox } from '../../../atoms/Checkbox.js';
import { FormItem } from '../FormItem.js';
import { ReadOnlyField, formatReadOnlyValue } from './ReadOnlyFormField.js';

/**
 * CheckboxFormField - A form field component for checkbox input.
 *
 * @example
 * ```tsx
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <CheckboxFormField
 *     schemaField="agreeToTerms"
 *     labelText="I agree to the terms and conditions"
 *   />
 * </Form>
 * ```
 */
function CheckboxFormField({ schemaField, labelText, descriptionText, isReadOnly, isDisabled, required, className, id, linkedField, showFieldToggle, ...checkboxProps }) {
    const { field } = useController({
        name: schemaField,
        shouldUnregister: false,
    });
    if (isReadOnly) {
        return (React__default.createElement(ReadOnlyField, { label: labelText, value: formatReadOnlyValue(field.value, 'checkbox'), description: descriptionText, required: required, className: className }));
    }
    return (React__default.createElement(FormItem, { schemaField: schemaField, labelText: labelText, descriptionText: descriptionText, required: required, className: className, id: id, isDisabled: isDisabled, linkedField: linkedField, showFieldToggle: showFieldToggle },
        React__default.createElement(Checkbox, { ...checkboxProps, isDisabled: isDisabled, isReadOnly: isReadOnly })));
}

export { CheckboxFormField };
//# sourceMappingURL=CheckboxFormField.js.map
